// extracted by mini-css-extract-plugin
module.exports = {"title":"AccreditedInvestorModal-module__title--160f3","text":"AccreditedInvestorModal-module__text--3Ao1w","spacer":"AccreditedInvestorModal-module__spacer--3cS7h"};